module.exports = __webpack_public_path__ + "static/media/logo-festival-online-conferenze-mobile.ef0dbd36.png";